import { Component, computed, inject, input } from '@angular/core';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { NodeTopa } from '@app/models/entity.model';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { HeroVImagesComponent } from '@app/components/hero-v-images/hero-v-images.component';
import { ContentLinkService } from '@app/services/contentLinks.service';
import { ParagraphLoaderComponent } from '@app/entities/paragraph/loader.component';

@Component({
  selector: 'mobi-node-topa',
  templateUrl: './node-topa.component.html',
  styleUrls: ['./node-topa.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    BreadcrumbComponent,
    HeroVImagesComponent,
    BreadcrumbComponent,
    ParagraphLoaderComponent,
  ],
})
export class NodeTopaComponent {
  readonly entity = input.required<NodeTopa>();
  #contentLink = inject(ContentLinkService);

  contentLinks = computed(() => {
    const paragraphs = this.entity()?.paragraphs;
    return this.#contentLink.getContentLinks(paragraphs);
  });
}
